import { Component } from '@angular/core';
import { RouterModule } from "@angular/router";

@Component({
  selector: 'app-cart-management',
  imports: [RouterModule],
  templateUrl: './cart-management.html',
  styleUrl: './cart-management.scss'
})
export class CartManagement {

}
